import { Icon } from "@iconify/react";
// import appleFilled from '@iconify/icons-ant-design/apple-filled';

// material
import { alpha, styled } from "@mui/material/styles";
import { Card, Typography, Box } from "@mui/material";
// utils
import { fShortenNumber } from "../../../utils/formatNumber";
// import { useTheme } from '@material-ui/styles';

// ----------------------------------------------------------------------

// const RootStyle = styled(Card)(({ theme }) => ({
//   boxShadow: "none",
//   textAlign: "center",
//   padding: theme.spacing(5, 0),
//   color: theme.palette.info.darker,
//   backgroundColor: theme.palette.info.lighter,
// }));

// const IconWrapperStyle = styled("div")(({ theme }) => ({
//   margin: "auto",
//   display: "flex",
//   borderRadius: "50%",
//   alignItems: "center",
//   width: theme.spacing(8),
//   height: theme.spacing(8),
//   justifyContent: "center",
//   marginBottom: theme.spacing(3),
//   color: theme.palette.info.dark,
//   backgroundImage: `linear-gradient(135deg, ${alpha(
//     theme.palette.info.dark,
//     0
//   )} 0%, ${alpha(theme.palette.info.dark, 0.24)} 100%)`,
// }));

export default function InfoCard(props) {
  return (
    <Card
      sx={{
        backgroundColor: props.color1,
        color: props.color2,
        boxShadow: "none",
        textAlign: "center",
        padding: (theme) => theme.spacing(5, 0),
      }}
    >
      <Box
        sx={{
          margin: "auto",
          display: "flex",
          borderRadius: "50%",
          alignItems: "center",
          width: (theme) => theme.spacing(8),
          height: (theme) => theme.spacing(8),
          justifyContent: "center",
          marginBottom: (theme) => theme.spacing(3),
          color: props.color2,
          backgroundImage: `linear-gradient(135deg, ${alpha(
            props.color2,
            0
          )} 0%, ${alpha(props.color2, 0.24)} 100%)`,
        }}
      >
        <Icon icon={props.icon} width={24} height={24} />
      </Box>
      <Typography variant="h3">{fShortenNumber(props.value)}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        {props.text}
      </Typography>
    </Card>
  );
}
